import React, { useRef, useLayoutEffect } from "react";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./OurStory.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Navigation, Pagination, Autoplay } from "swiper/modules";
import { paragraphs2, paragraghs1 } from "./Texts";

import logo from "./Images/IMG_5076.jpg"
import logo2 from "./Images/IMG_5077.jpg"
import logo3 from "./Images/IMG_5081.jpg"
import logo4 from "./Images/IMG_5083.jpg"
import logo5 from "./Images/IMG_6301.jpg"
import logo6 from "./Images/image1.jpeg"

const images = [logo, logo2, logo3, logo4, logo5, logo6]


export default function Ourstory() {
  const revealRef = useRef([]);

  useLayoutEffect(() => {
    const els = revealRef.current.filter(Boolean);
    if (!els.length) return;

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("show");
        });
      },
      {
        threshold: 0.01,                 // easier to trigger
        rootMargin: "0px 0px -10% 0px",  // trigger a bit earlier
      }
    );

    // Wait one frame so Swiper/layout settles, then observe
    const raf = requestAnimationFrame(() => {
      els.forEach((el) => obs.observe(el));
    });

    return () => {
      cancelAnimationFrame(raf);
      obs.disconnect();
    };
  }, []);

  return (
    <section className="memorial-page">
      <div className="hero">
        <div className="slideshow-wrap">
          <div className="slide-frame">
                      <Swiper
            modules={[EffectFade, Navigation, Pagination, Autoplay]}
            effect="fade"
            autoplay={{ delay: 7000, disableOnInteraction: false }}
            loop={true}
            pagination={{
              clickable: true,
              renderBullet: (index, className) => {
                const map = ["dot-red", "dot-yellow", "dot-black"];
                return `<span class="${className} ${map[index % 3]}"></span>`;
              },
            }}
            navigation={{ enabled: true }}
            breakpoints={{
              0: { navigation: { enabled: false } },
              768: { navigation: { enabled: true } },
            }}
          >
            {images.map((src, i) => (
              <SwiperSlide key={i}>
                <div className="slide-frame">
                  <img src={src} alt="Memorial slideshow" />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          </div>
        </div>
        <h1 className="page-title">The Beth Branson Memorial</h1>
      </div>

      <div
        className="section about reveal"
        ref={(el) => (revealRef.current[0] = el)}
      >
        <h2>About Beth</h2>
        {paragraghs1.map(p => (
          <p>{p}</p>
        ))}
      </div>

      <div
        className="section why reveal"
        ref={(el) => (revealRef.current[1] = el)}
      >
        <h2>Why This Match Exists</h2>
        {paragraphs2.map(p => (
          <p>{p}</p>
        ))}
      </div>
    </section>
  );
}
